// base
import React, { useEffect } from 'react';

// hooks
import { useIconControl } from 'hooks';

// libraries
import gsap from 'gsap';
import { useGLTF } from '@react-three/drei';

useGLTF.preload('/assets/models/icons/security_sign/security_sign.gltf');

export const SecuritySign = (props) => {
  const { onClick, ...rest } = props;


  const { scene, nodes, materials } = useGLTF(
    '/assets/models/icons/security_sign/security_sign.gltf'
  );
  const { hovered, setHovered, iconRef } = useIconControl({
    onClick
  })

  useEffect(() => {
    scene.traverse((mesh) => {
      if (mesh.isMesh) {
        mesh.material.metalness = 0;
        mesh.material.roughness = 1;
        mesh.material.shininess = 2;
        mesh.material.color.set(0xffff00);
      }
    });

    if (!iconRef.current) return;

    const rotationTween = gsap.to(iconRef.current.rotation, {
      duration: 3,
      repeat: -1,
      yoyo: false,
      ease: 'none',
      y: Math.PI * 2,
    });

    return () => {
      rotationTween.kill();
    };
  }, []);

  useEffect(() => {
    if (!iconRef.current) return;

    gsap.to(iconRef.current.scale, {
      duration: 0.5,
      x: hovered ? 7.5 : 5.5,
      y: hovered ? 7.5 : 5.5,
      z: hovered ? 7.5 : 5.5
    });
  }, [hovered]);

  return (
    <group
      {...rest}
      dispose={null}
      ref={iconRef}
      scale={[5.5, 5.5, 5.5]}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      onPointerDown={onClick}
    >
      <group position={[0, 7.6, 0]} rotation={[0, 1.518, -Math.PI / 2]} scale={[10, 100, 10]}>
        <mesh geometry={nodes.Plane.geometry} material={materials.Material_sign_english} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials['Material_sign_english.002']} />
      </group>
    </group>
  );
};
